/* eslint-disable */
import { useState, ReactNode, useEffect, useContext } from 'react'
import ChooseOrgAndApp from '../../pages/ChooseOrgAndApp'
import { OrgAppContext } from '../../OrgAppContext'
import { AuthContext } from '../../Auth'

export const ChooseOrgAndAppProvider = ({ children }: { children: ReactNode }) => {
  const { auth } = useContext(AuthContext)

  const [customerId, setCustomerId] = useState<string>(
    () => sessionStorage.getItem('customerId') || ''
  )
  const [orgId, setOrgId] = useState<string>(() => sessionStorage.getItem('orgId') || '')
  const [appId, setAppId] = useState<string>(() => sessionStorage.getItem('appId') || '')
  const [orgName, setOrgName] = useState<string>(() => sessionStorage.getItem('orgName') || '')
  const [appName, setAppName] = useState<string>(() => sessionStorage.getItem('appName') || '')
  const hasSelectedAll = Boolean(customerId && orgId && appId)
  useEffect(() => {
    if (customerId) sessionStorage.setItem('customerId', customerId)
    if (orgId) sessionStorage.setItem('orgId', orgId)
    if (appId) sessionStorage.setItem('appId', appId)
    if (orgName) sessionStorage.setItem('orgName', orgName)
    if (appName) sessionStorage.setItem('appName', appName)
  }, [customerId, orgId, appId, auth])

  return (
    <OrgAppContext.Provider
      value={{
        customerId,
        orgId,
        appId,
        orgName,
        setOrgName,
        appName,
        setAppName,
        setCustomerId,
        setOrgId,
        setAppId,
      }}
    >
      {hasSelectedAll ? children : <ChooseOrgAndApp />}
    </OrgAppContext.Provider>
  )
}
